import { Drawer } from "@/js/components/Drawer";

class HeaderDrawer {
    static attach() {
        /* eslint-disable-next-line no-unused-vars */
        const headerDrawer = new HeaderDrawer();
    }

    constructor() {
        this.drawer = new Drawer({
            open: ".js-header__open-drawer",
            close: ".js-header__close-drawer",
            drawer: ".js-header__drawer"
        });

        this.bindEvents();
    }

    getHeaderTitleHeight() {
        const headerCloseAndTitleElement = this.drawer.drawerElement.querySelector(
            ".js-header__close-drawer-and-title"
        );
        if (headerCloseAndTitleElement) {
            return headerCloseAndTitleElement.offsetHeight;
        }

        return 0;
    }

    bindEvents() {
        if (this.drawer.drawerElement) {
            const headerCategoryContainerElement = this.drawer.drawerElement.querySelector(
                ".js-header__category-container"
            );
            if (headerCategoryContainerElement) {
                this.drawer.drawerElement.addEventListener("drawer.open", () => {
                    headerCategoryContainerElement.style.height = `calc(100% - ${this.getHeaderTitleHeight()}px)`;
                });
                window.addEventListener("resize", () => {
                    headerCategoryContainerElement.style.height = `calc(100% - ${this.getHeaderTitleHeight()}px)`;
                });
            }
        }
    }
}

export { HeaderDrawer };
